import { render, staticRenderFns } from "./EntitysList.vue?vue&type=template&id=490c0503&scoped=true&"
import script from "./EntitysList.vue?vue&type=script&lang=js&"
export * from "./EntitysList.vue?vue&type=script&lang=js&"
import style0 from "./EntitysList.vue?vue&type=style&index=0&id=490c0503&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490c0503",
  null
  
)

component.options.__file = "EntitysList.vue"
export default component.exports